import React from "react";
import { connect } from "react-redux";
import {
    Container,
    Grid,
    Typography, AppBar, Toolbar, Table, TableBody, TableRow, TableCell, Avatar
} from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { Person } from "@mui/icons-material"
import { withTranslation } from 'react-i18next';
import { formatDate, authHeader } from "../../_helpers";
import { flushSync } from "react-dom";

const { webApiUrl } = window.appConfig;

const styles = theme => ({
    appBar:{
    },
    bold: {
        fontWeight: "bold"
    },
    mainContainer: {
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0)
        }
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        margin: theme.spacing(5, 0, 6),
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(0)
        }
    },
    innerContainer: {
        padding: theme.spacing(2, 3, 4)
    },
    bigAvatar: {
        margin: 'auto',
        width: 120,
        height: 120
    },
    divWithHtmlContent: {
        maxWidth: '100%',
        overflowX: 'auto',
        '& *': {
            maxWidth: '100%'
        }
    },
    button: {
        '&:hover': {
            color: theme.palette.primary.contrastText
        }
    }
});


class Page extends React.Component {
    state = {
        projectInfo: null,
        relaties: []
    };

    componentDidMount() {
        this.UpdateProjectInfo();
        this.UpdateRelatiesInfo();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.selected || !this.props.selected || prevProps.selected.projectId.toUpperCase() !== this.props.selected.projectId.toUpperCase()) {
            this.UpdateProjectInfo();
            this.UpdateRelatiesInfo();
        }
    }

    UpdateProjectInfo() {
        const { selected } = this.props;
        if (selected) {
            const url = webApiUrl + 'api/home/GetProjectInfo/' + encodeURI(selected.projectId);
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
          flushSync(()=>{
           this.setState({
                projectInfo: null,
                relaties: []
            });
          })
            

            fetch(url, requestOptions)
                .then(Response => Response.json())
                .then(findResponse => {
                    flushSync(()=>{this.setState({ projectInfo: findResponse });})
                });
        }
    }

    UpdateRelatiesInfo() {
        const { selected } = this.props;
        if (selected) {
            const url = webApiUrl + 'api/home/GetRelationsByProject/' + encodeURI(selected.projectId);
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };

            flushSync(()=>{
                this.setState({
                projectInfo: null,
                relaties: []
            });
            })

            fetch(url, requestOptions)
                .then(Response => Response.json())
                .then(findResponse => {
                    flushSync(()=>{this.setState({ relaties: findResponse });})
                });
        }
    }


    render() {
        const { t, classes } = this.props;
        const { projectInfo, relaties } = this.state;
        return (
            (<Container className={classes.mainContainer}>
                <Grid container>
                    <Grid container className={classes.container} size={{xs:12}}>
                        <AppBar position="sticky" color='inherit' className={classes.appBar}>
                            <Toolbar variant="dense">
                                <Typography className={classes.bold}>{projectInfo ? projectInfo.projectName : ''}</Typography>
                            </Toolbar>
                        </AppBar>
                        {
                            projectInfo &&
                            <Grid
                                container
                                spacing={2}
                                direction="row-reverse"
                                className={classes.innerContainer}
                                size={{xs:12}}>
                                <Grid
                                    container
                                    sx={{
                                        alignContent: "flex-start"
                                    }}
                                    size={{
                                        xs: 12,
                                        md: 4
                                    }}>
                                    {
                                        //    <Grid item xs={12}>
                                        //    <Typography variant="h6">{t('general.buyersGuide')}</Typography>
                                        //</Grid>
                                    }
                                    <Grid size={{xs: 12}}>
                                        <Table>
                                            <TableBody>
                                                {
                                                    relaties.map((relatie, index) => (
                                                        <React.Fragment key={index}>

                                                            <TableRow>
                                                                <TableCell component="th" colSpan={2} align="center">
                                                                    {
                                                                        relatie.hasPhoto === true ?
                                                                            <Avatar alt={relatie.fullName} src={webApiUrl + "api/home/GetPersonPhoto/" + relatie.personId} className={classes.bigAvatar} />
                                                                            :
                                                                            <Avatar className={classes.bigAvatar} >
                                                                                <Person fontSize="large" />
                                                                            </Avatar>
                                                                    }
                                                                </TableCell>
                                                            </TableRow>
                                                            {
                                                                relatie.fullName && relatie.fullName.trim() !== '' &&
                                                                <TableRow>
                                                                    <TableCell component="th">
                                                                        {t('general.name') + ':'}
                                                                    </TableCell>
                                                                    <TableCell>{relatie.fullName}</TableCell>
                                                                </TableRow>
                                                            }
                                                            {
                                                                relatie.function && relatie.function.trim() !== '' &&
                                                                <TableRow>
                                                                    <TableCell component="th">
                                                                        {t('general.function') + ':'}
                                                                    </TableCell>
                                                                    <TableCell>{relatie.function}</TableCell>
                                                                </TableRow>
                                                            }
                                                            {
                                                                relatie.email && relatie.email.trim() !== '' &&
                                                                <TableRow>
                                                                    <TableCell component="th" scope="row">
                                                                        {t('general.email') + ':'}
                                                                    </TableCell>
                                                                    <TableCell>{relatie.email}</TableCell>
                                                                </TableRow>
                                                            }{
                                                                relatie.telephone && relatie.telephone.trim() !== '' &&
                                                                <TableRow>
                                                                    <TableCell component="th" scope="row">
                                                                        {t('general.telephone') + ':'}
                                                                    </TableCell>
                                                                    <TableCell>{relatie.telephone}</TableCell>
                                                                </TableRow>
                                                            }{
                                                                relatie.mobile && relatie.mobile.trim() !== '' &&
                                                                <TableRow>
                                                                    <TableCell component="th" scope="row">
                                                                        {t('buyersGuide.mobile') + ':'}
                                                                    </TableCell>
                                                                    <TableCell>{relatie.mobile}</TableCell>
                                                                </TableRow>
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    size={{
                                        xs: 12,
                                        md: 8
                                    }}>
                                    <Grid size={{xs: 12}}>
                                        <Typography variant="h6">{t('general.generalInformation')}</Typography>
                                        <Table>
                                            <TableBody>
                                                {
                                                    projectInfo.projectNo && projectInfo.projectNo.trim() !== '' &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.projectNumber') + ':'}
                                                        </TableCell>
                                                        <TableCell>{projectInfo.projectNo}</TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    projectInfo.projectName && projectInfo.projectName.trim() !== '' &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.projectName') + ':'}
                                                        </TableCell>
                                                        <TableCell>{projectInfo.projectName}</TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    projectInfo.place && projectInfo.place.trim() !== '' &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.address.city') + ':'}
                                                        </TableCell>
                                                        <TableCell>{projectInfo.place}</TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    projectInfo.objectsCount &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('buyersGuide.numberOfObjects') + ':'}
                                                        </TableCell>
                                                        <TableCell>{projectInfo.objectsCount}</TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    projectInfo.projectType && projectInfo.projectType.trim() !== '' &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.project.typeProject') + ':'}
                                                        </TableCell>
                                                        <TableCell>{projectInfo.projectType}</TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    projectInfo.projectConstructionType && projectInfo.projectConstructionType.trim() !== '' &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.project.constructionTypeProject') + ':'}
                                                        </TableCell>
                                                        <TableCell>{projectInfo.projectConstructionType}</TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    projectInfo.projectPhase && projectInfo.projectPhase.trim() !== '' &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.phase') + ':'}
                                                        </TableCell>
                                                        <TableCell>{projectInfo.projectPhase}</TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    projectInfo.saleStartDate && projectInfo.saleStartDate.trim() !== '' &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('general.salesStartDate') + ':'}
                                                        </TableCell>
                                                        <TableCell>{formatDate(new Date(projectInfo.saleStartDate))}</TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    projectInfo.dateStartConstruction && projectInfo.dateStartConstruction.trim() !== '' &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('buyersGuide.constructionStartDate') + ':'}
                                                        </TableCell>
                                                        <TableCell>{formatDate(new Date(projectInfo.dateStartConstruction))}</TableCell>
                                                    </TableRow>
                                                }
                                                {
                                                    projectInfo.dateEndConstruction && projectInfo.dateEndConstruction.trim() !== '' &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            {t('buyersGuide.constructionEndDate') + ':'}
                                                        </TableCell>
                                                        <TableCell>{formatDate(new Date(projectInfo.dateEndConstruction))}</TableCell>
                                                    </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </Grid>

                                    <Grid size={{xs: 12}}>
                                        <br />
                                        <Typography variant="h6">{t('buyersGuide.otherGeneralInformation')}</Typography>
                                        <div className={classes.divWithHtmlContent} dangerouslySetInnerHTML={{ __html: projectInfo.generalInfo }} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Container>)
        );
    }
}

function mapStateToProps(state) {
    const { authentication, buildings } = state;
    const { user } = authentication;
    const { selected } = buildings;
    return {
        user,
        selected
    };
}

const connectedPage = connect(mapStateToProps)(withTranslation()(withStyles(styles)(Page)));
export { connectedPage as GeneralProjectInfoPage };